<h4 class="mb-3"><i class="fa-solid fa-plus me-2"></i>Yeni Toplantı</h4>

@if (error) {
  <div class="alert alert-danger py-2">{{ error }}</div>
}

@if (loading) {
  <div class="panel-card text-center py-5">
    <i class="fa-solid fa-spinner fa-spin fa-2x mb-3" style="color: var(--brand-accent)"></i>
    <div class="text-muted">{{ loadingText }}</div>
  </div>
} @else if (step === 1) {

  <!-- ADIM 1: Ad, konu, tür, bütçe -->
  <div class="panel-card">
    <div class="mb-3" style="max-width: 340px;">
      <label class="form-label fw-semibold">Adınız</label>
      <input class="form-control" [(ngModel)]="userName" maxlength="100">
      <div class="form-text">Toplantıda bu isimle görüneceksiniz.</div>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">Toplantı konusu</label>
      <app-rich-editor [(ngModel)]="topic"></app-rich-editor>
      <div class="form-text">Konuyu detaylandırabilir, madde madde yazabilirsiniz. Biçimlendirme için üstteki araç çubuğunu kullanın.</div>
    </div>

    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label fw-semibold">Toplantı türü</label>
        <select class="form-select" [(ngModel)]="meetingType">
          <option value="">Sistem önersin</option>
          @for (t of meetingTypes; track t) {
            <option [value]="t">{{ t }}</option>
          }
        </select>
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold">Toplantı derinliği</label>
        <select class="form-select" [(ngModel)]="model">
          @for (o of modelOptions; track o.value) {
            <option [value]="o.value">{{ o.label }}</option>
          }
        </select>
        <div class="form-text">{{ selectedModelDescription }}</div>
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold">Kredi bütçesi</label>
        <div class="input-group">
          <input type="number" class="form-control" [(ngModel)]="creditBudget" min="1" step="5">
          <span class="input-group-text">kredi</span>
        </div>
        <div class="form-text">Toplantı bu kredi bütçesi içinde yürütülür; bütçe dolunca moderatör toplantıyı kapatır.</div>
      </div>
    </div>

    <div class="text-end mt-4">
      <button class="btn btn-primary px-4" (click)="create()">
        Toplantıyı Hazırla <i class="fa-solid fa-arrow-right ms-1"></i>
      </button>
    </div>
  </div>

} @else {

  <!-- ADIM 2: Moderatör ön görüşü + uzman onayı -->
  <div class="panel-card mb-3 moderator-opinion">
    <div class="d-flex gap-3">
      <div class="op-avatar">M</div>
      <div>
        <strong>Moderatör ön görüşü</strong>
        <span class="badge text-bg-light ms-2">{{ suggestedType }}</span>
        <p class="mb-0 mt-2">{{ moderatorOpinion }}</p>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between align-items-center mb-2">
    <h6 class="m-0">Önerilen uzmanlar <span class="text-muted">({{ includedCount }} seçili)</span></h6>
    <button class="btn btn-sm btn-outline-primary" (click)="addExpert()">
      <i class="fa-solid fa-user-plus me-1"></i> Uzman Ekle
    </button>
  </div>

  <div class="expert-grid mb-3">
    @for (e of experts; track $index; let i = $index) {
      <div class="panel-card expert-card" [class.excluded]="!e.include">
        <div class="d-flex justify-content-between align-items-start mb-2">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" [(ngModel)]="e.include" id="exp{{i}}">
            <label class="form-check-label fw-semibold" for="exp{{i}}">
              {{ e.code }}
              @if (!e.isRequired) { <span class="badge text-bg-light ms-1">Opsiyonel</span> }
            </label>
          </div>
          <button class="btn btn-sm btn-link text-danger p-0" title="Kaldır" (click)="removeExpert(i)">
            <i class="fa-solid fa-trash-can"></i>
          </button>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-4"><input class="form-control form-control-sm" [(ngModel)]="e.code" placeholder="Kod (CTO)"></div>
          <div class="col-8"><input class="form-control form-control-sm" [(ngModel)]="e.name" placeholder="İsim"></div>
        </div>
        <input class="form-control form-control-sm mb-2" [(ngModel)]="e.title" placeholder="Rol başlığı">
        <label class="form-label mb-1 small text-muted">Rol prompt'u (düzenlenebilir)</label>
        <textarea class="form-control form-control-sm" rows="4" [(ngModel)]="e.rolePrompt"></textarea>
      </div>
    }
  </div>

  <div class="panel-card d-flex flex-wrap justify-content-between align-items-center gap-3">
    <div class="d-flex flex-wrap gap-4 align-items-end">
      <div>
        <label class="form-label fw-semibold mb-1">Kredi bütçesi (onay)</label>
        <div class="input-group input-group-sm" style="max-width: 200px;">
          <input type="number" class="form-control" [(ngModel)]="creditBudget" min="1" step="5">
          <span class="input-group-text">kredi</span>
        </div>
      </div>
      <div>
        <label class="form-label fw-semibold mb-1 d-block">Derinlik</label>
        <span class="badge text-bg-light fs-6">{{ selectedModelLabel }}</span>
      </div>
    </div>
    <button class="btn btn-primary btn-lg px-4" (click)="startMeeting()">
      <i class="fa-solid fa-play me-2"></i>Onayla ve Toplantıyı Başlat
    </button>
  </div>
}
